import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    padding: theme.spacing(3),
    backgroundColor: '#fff',
  },
  root: {
    width: '100%',
  },
  searchTextField: {
    width: '30%',
    marginBottom: theme.spacing(2),
    backgroundColor: '#F5F5F5',
    borderRadius: '8px',
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
  },
}));
